<template>
  <div class="notification">
    <div class="icon-container">
      <img :src="notificationImage">
    </div>
    <div class="notification-content">
      <p class="title">{{ notificacion.Titulo }}</p>
      <p class="time texto-light">{{ formattedFechaCreacion }}</p>
      <p class="description">{{ notificacion.Mensaje }}</p>
    </div>
    <DxButton v-if="!leida" icon="fa-regular fa-envelope" @click="marcarLeido(notificacion)" class="mark-as-read" />
  </div>
</template>

<script setup lang="ts">
import { DxButton } from "devextreme-vue/button";
import type { NotificacionModel } from '@/.shared/.api/api';
import type { PropType } from "vue";
import { computed } from 'vue';
import { useApi } from "@/.shared/.api/integration";

const props = defineProps({
  notificacion: {
    type: Object as PropType<NotificacionModel>,
    required: true
  },
  leida: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['notificacion-leida']);
const api = useApi();

const formattedFechaCreacion = computed(() => {
  const date = new Date(props.notificacion.FechaCreacion);
  return date.toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
});

const notificationImage = computed(() => {
  var categoriaNotificacion = props.notificacion.Tipo.split('.')[0];
  switch (categoriaNotificacion) {
    case 'Operacion':
      return new URL('../../assets/images/operaciones-on.svg', import.meta.url).href;
    case 'Factura':
      return new URL('../../assets/images/facturas.svg', import.meta.url).href;
    case 'RappelsMensuales':
      return new URL('../../assets/images/liquidaciones-on.svg', import.meta.url).href;
    case 'Ticket':
      return new URL('../../assets/images/soporte-on.svg', import.meta.url).href;
    case 'TramiteEnergia':
      return new URL('../../assets/images/operaciones-on.svg', import.meta.url).href;
    case 'BorradorOperacion':
      return new URL('../../assets/images/operaciones-on.svg', import.meta.url).href;
    default:
      return '';
  }
});

const marcarLeido = async (notificacion: NotificacionModel) => {
  await api.callStandardApi("readNotificacion", { showLoading: false }, notificacion.Id)
    .then(data => {
      emit('notificacion-leida');
    })
};
</script>

<script>
</script>